export default __webpack_public_path__ + "2f4e3ba9e20f53053f4ffd56b39d7d63.png";